import React from 'react'
import PropTypes from 'prop-types'


// STYLE //
import './stylesHome.scss'

// COMPONENTS //
import Header from '../../components/Header/Header'
import Main from '../../components/Main/Main'
import Footer from '../../components/Footer/Footer'

function Home(props) {
  return (
    <div className='home'>
        <Header />
        <Main />
      
    </div>
  )
}

export default Home
